import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-ag-grid-column-def',
	templateUrl:'./AgGridColumnDefPluginCompPage.html',
	styles: [],
	styleUrls:['./AgGridColumnDefPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class AgGridColumnDefPluginCompPage
{
	mdContent_709 = `\`\`\`java
import com.jwebmp.plugins.aggrid.AgGridColumnDef;
\`\`\``;
	mdContent_710 = `\`\`\`java
AgGridColumnDef()
\`\`\``;
	mdContent_711 = `\`\`\`java
AgGridColumnDef(String field)
\`\`\``;
	mdContent_712 = `\`\`\`java
AgGridColumnDef(String field, String headerName)
\`\`\``;
	mdContent_713 = `\`\`\`java
new AgGridColumnDef&lt;&gt;("name", "Full Name")
    .setSortable(true)
    .setFilter(true)
    .setFlex(1);
\`\`\``;
	mdContent_714 = `\`\`\`java
new AgGridColumnDef&lt;&gt;("price", "Price")
    .setEditable(true)
    .setValueFormatter("params =&gt; '$' + params.value.toFixed(2)")
    .setWidth(120);
\`\`\``;
	mdContent_715 = `\`\`\`java
new AgGridColumnDef&lt;&gt;()
    .setHeaderName("Contact Info")
    .setChildren(List.of(
        new AgGridColumnDef&lt;&gt;("email", "Email"),
        new AgGridColumnDef&lt;&gt;("phone", "Phone")
    ))
    .setMarryChildren(true);
\`\`\``;
	mdContent_716 = `\`\`\`java
new AgGridColumnDef&lt;&gt;("country", "Country")
    .setRowGroup(true)
    .setRowGroupIndex(0);

new AgGridColumnDef&lt;&gt;("revenue", "Revenue")
    .setAggFunc("sum")
    .setValueFormatter("params =&gt; '$' + params.value");
\`\`\``;
}
